export default __webpack_public_path__ + "static/media/angle-double-up.598ab522.svg";